export const dataQuotes = [
   {
      id: 1,
      quote: "☝️ The journey, not the destination, shapes your destiny",
   },

   {
      id: 2,
      quote: "💚 In the flow of the Force, find balance and strength",
   },

   {
      id: 3,
      quote: "🧠 Navigate life's path with mindful steps",
   },

   {
      id: 4,
      quote: "🚀 Adventure awaits, where you least expect it",
   },

   {
      id: 5,
      quote: "📖 To grow, we must unlearn what we have learned",
   },

   {
      id: 6,
      quote: "🦄 Trust in the Force, follow your instincts",
   },
];
